module.exports = __webpack_public_path__ + "static/img/072.1f49d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/072.png
// module id = bAR8
// module chunks = 0